import { forwardRef } from 'react';
import cn from 'classnames';

import { rewardsBgImages } from '@/assets/img/reward/reward-bg';
import { createBgSet } from '@/common/lib/createBgSet';

import { Picture } from '../Picture/Picture';

import { type CommonRewardProps, commonRewardVariants } from './config';

import css from './styles.module.scss';

const CommonReward = forwardRef<HTMLDivElement, CommonRewardProps>(
  ({ size, bgVariant, icon, label, ...props }, ref) => {
    const { png, webp } = rewardsBgImages[bgVariant];

    return (
      <div
        ref={ref}
        {...props}
        style={{
          ...props.style,
          backgroundImage: createBgSet(png, webp),
        }}
        className={cn(
          commonRewardVariants({ size }),
          css.commonReward,
          props.className,
        )}
      >
        <Picture {...icon} />
        {label && label()}
      </div>
    );
  },
);

export { CommonReward, type CommonRewardProps };
